import React from 'react';

import { Stack, Typography } from '@lyearn/ui';

interface SlideListItemSkeletonProps {
  index: number;
}

export function SlideListItemSkeleton({ index }: SlideListItemSkeletonProps) {
  return (
    <Stack className="flex w-full items-start gap-8 text-start">
      <Typography
        className="mt-16 min-w-[2rem] text-center"
        color="text-text-placeholder"
        variant="body-short-01">
        {index + 1}
      </Typography>
      <Stack className="relative h-[10.3rem] w-[18.4rem] overflow-hidden rounded-8 border-2 border-divider bg-bg-primary">
        <Stack className="absolute left-12 top-12 w-[70%]" direction="col" gap={8}>
          <Stack className="h-[1.4rem] rounded-8 bg-bg-secondary" />
          <Stack className="h-[1.4rem] w-[42%] rounded-8 bg-bg-secondary" />
        </Stack>
        <Stack className="absolute bottom-16 left-12 w-[56%]" direction="col" gap={6}>
          <Stack className="h-[0.8rem] rounded-8 bg-bg-secondary" />
          <Stack className="h-[0.8rem] rounded-8 bg-bg-secondary" />
          <Stack className="h-[0.8rem] w-[90%] rounded-8 bg-bg-secondary" />
        </Stack>
        <Stack className="absolute bottom-14 right-14 h-[5rem] w-[5rem] rounded-full bg-bg-secondary" />
      </Stack>
    </Stack>
  );
}

interface SlideEditorSkeletonProps {
  slideIndex: number;
  t: (key: string) => string;
}

export function SlideEditorSkeleton({ slideIndex, t }: SlideEditorSkeletonProps) {
  return (
    <Stack className="mx-16 rounded-12 bg-bg-secondary p-28" direction="col">
      <Stack alignItems="start" direction="row" gap={20}>
        <Typography
          className="mt-12 font-semibold"
          color="text-text-secondary"
          variant="heading-xs">
          {slideIndex + 1}
        </Typography>
        <Stack className="relative h-[12.2rem] w-[21.8rem] shrink-0 overflow-hidden rounded-8 border border-divider bg-bg-primary p-12">
          <Stack className="w-[70%]" direction="col" gap={8}>
            <Stack className="h-[1.4rem] rounded-8 bg-bg-secondary" />
            <Stack className="h-[1.4rem] w-[42%] rounded-8 bg-bg-secondary" />
          </Stack>
          <Stack className="absolute bottom-16 left-12 w-[56%]" direction="col" gap={6}>
            <Stack className="h-[0.8rem] rounded-8 bg-bg-secondary" />
            <Stack className="h-[0.8rem] rounded-8 bg-bg-secondary" />
            <Stack className="h-[0.8rem] w-[90%] rounded-8 bg-bg-secondary" />
          </Stack>
          <Stack className="absolute bottom-14 right-14 h-[5rem] w-[5rem] rounded-full bg-bg-secondary" />
        </Stack>
        <Stack className="min-w-0 flex-1" direction="col" gap={20}>
          <Stack direction="col" gap={8}>
            <Typography color="text-text-primary" variant="body-short-02">
              {t('Course:AiVideoGeneration.SlideContent')}
            </Typography>
            <Stack className="h-[5rem] w-full rounded-8 border border-border bg-bg-primary px-16 py-14">
              <Typography color="text-text-placeholder" variant="body-short-01">
                Generating slide content...
              </Typography>
            </Stack>
          </Stack>
          <Stack direction="col" gap={8}>
            <Typography color="text-text-primary" variant="body-short-02">
              {t('Course:AiVideoGeneration.SpeechText')}
            </Typography>
            <Stack className="h-[12rem] w-full rounded-8 border border-border bg-bg-primary px-16 py-14">
              <Typography color="text-text-placeholder" variant="body-short-01">
                Generating speech text...
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
}
